import React, { FC } from "react";
export const Privacy: FC = () => (
  <section style={{ maxWidth: 1000, padding: "2em", margin: "auto" }}>
    <p className="p1">
      <span className="s1">
        <strong>PRIVACY &amp; COOKIE POLICY</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        This Privacy Policy ("<strong>Policy</strong>") governs the collection,
        use, holding and processing of personal data in connection with your use
        of the CELESTION website at Celestion.com, ("<strong>Website</strong>")
        and the CELESTION Speakers Mobile Application ("<strong>App</strong>"),
        both of which are operated by GP Acoustics UK Limited, as well as the
        collection of your personal data at CELESTION&rsquo;s Physical Locations
        (defined below) by GP Acoustics UK Limited, its subsidiaries and
        affiliated companies as listed under Section 14 of this Policy
        (collectively referred to below as "<strong>CELESTION</strong>", "
        <strong>we</strong>", "<strong>us</strong>" or "<strong>our</strong>").
        Please also refer to Section 14 for our contact details.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We have certain legal obligations under the laws and regulations of the
        countries in which we collect, use, hold and/or processes your personal
        data. This Policy is designed to provide you with information on how and
        why we gather your personal data, the type of personal data we collect,
        what we use them for, when we might disclose them and how you can manage
        your personal data. If you are accessing and using the Website and/or
        the App from and/or visiting CELESTION&rsquo;s Physical Locations
        outside the European Economic Area ("<strong>EEA</strong>"), by
        accessing and/or using the Website, downloading and/or using the App, as
        well as providing your personal information to us at CELESTION&rsquo;s
        Physical Locations and via email correspondences outside the EEA, you
        are accepting our Policy below. If you do not agree to the terms of this
        Policy, please stop accessing or using the Website, or downloading or
        using the App, and do not provide your personal information to us
        whether through the Website, the App, at CELESTION&rsquo;s Physical
        Locations, email correspondences or otherwise. If you are accessing and
        using our Website and/or App from within the EEA (i.e. including an EU
        Member State), or if you visit CELESTION&rsquo;s Physical Locations
        and/or send email correspondences to us within the EEA, please refer to
        Section 13 of this Policy which applies in conjunction with the
        remaining Sections of the Policy.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you are less than the age of majority in the country where you live,
        and:
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s3">
          if you are accessing and using the Website and/or the App from and/or
          visiting CELESTION&rsquo;s Physical Locations outside the EEA, you
          must have a legal representative such as a parent or guardian accept
          this Policy on your behalf.
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          if you are accessing and using the Website and/or the App from and/or
          visiting CELESTION&rsquo;s Physical Locations within the EEA, please
          refer to Section 13.1 of this Policy which applies in conjunction with
          the remaining Sections of the Policy.
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        We reserve the right to change the provisions of this Policy at any time
        and you should review the terms of this Policy from time to time. We
        will alert you that changes have been made by indicating on this Policy
        the date it was last updated and by publishing a notice regarding such
        changes on the Website and/or the App and/or by sending notifications to
        you via the App. Your continued use of the Website, App and/or
        CELESTION&rsquo;s services following the posting or notification of
        changes to these terms will mean you accept those changes. If you have
        any questions about this Policy, you should contact us at&nbsp;
        <a href="mailto:data@Celestion.com">
          <span className="s4">data@Celestion.com</span>
        </a>
        .
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>1. What and how personal data is collected from you</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We generally collect two types of data from you: &ldquo;Personal
        Data&rdquo; and &ldquo;Non-Personal Data&rdquo;.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        "Personal Data" is any information that can identify a person
        individually and includes name, e-mail and/or postal address, telephone
        number, user name, password, date of birth, gender, credit card number,
        billing and/or other contact information, company, job title, education,
        marital status and interests and purchase activity. If you are accessing
        and using the Website and/or the App from and/or visiting
        CELESTION&rsquo;s Physical Locations within the EEA, the following
        information may also amount to Personal Data to the extent that they can
        be used to identify you individually: IP address, geo-location
        information, browsing preferences, device information, unique device
        identifiers and information about your use of the App and/or Website (as
        described in more detail, below, in the section &ldquo;Collection of
        Non-Personal Data&rdquo;). Personal Data may be supplied to us at
        various instances including when you register for a membership account
        or purchase products as a guest on the Website, register and/or use the
        App, when you purchase goods or use our services at the CELESTION
        Physical Locations, as well as through other means such as those listed
        in section 1.1 below.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        "Non-Personal Data" includes "aggregate" and/or automatic information,
        which is data collected about the use of the Website or App or about a
        group or category of users from which individual identities or other
        individually identifiable information has been removed. This Policy does
        not restrict or limit our collection, use and provision of Non-Personal
        Data, unless required by local law.
      </span>
    </p>
    <p className="p2">
      <span className="s1">1.1 Collection of Personal Data</span>
    </p>
    <p className="p2">
      <span className="s1">
        The following are the most common situations when we may collect and
        store your Personal Data, and by using the Website and/or App and/or
        visiting CELESTION Physical Locations, you agree to us collecting your
        Personal Data through the following means, although these means are not
        exhaustive:
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s3">registration to use the App and/or Website;</span>
      </li>
      <li className="li3">
        <span className="s3">
          browsing, using, purchasing products, signing-up for CELESTION&rsquo;s
          newsletters through the App and/or Website and/or otherwise using
          CELESTION&rsquo;s services through the App and/or Website
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          visiting CELESTION&rsquo;s point of sale locations and marketing
          campaigns ("<strong>CELESTION Physical Locations</strong>");
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          visiting CELESTION&rsquo;s social media platforms, including but not
          limited to CELESTION&rsquo;s Website, Facebook or Instagram page) and
          creating user-generated contents on those platforms (such as comments,
          discussions, likes, private messages, etc.);
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          submission of surveys and/or event questionnaires (e.g. via webforms
          on the Website) and entry into sales promotions;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          registration for product warranties and maintenance services;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          request for customer service or other assistance on the App and/or
          Website.
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          contacting us by email, post, fax or any other means of communication
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        We may also collect your Personal Data from social media sites: when you
        log in to use the App or Website or accesses CELESTION&rsquo;s social
        media platforms (such as CELESTION&rsquo;s Facebook or Instagram pages)
        using your Facebook or other social media accounts, we may collect the
        Personal Data that is made available to us on that page or account
        including your account ID / username, profile, mobile number and other
        information and activities about you on Facebook and/or other social
        media accounts. However, we will endeavour to comply with the privacy
        policies of the corresponding social media platform and will only
        collect and store such Personal Data that we are permitted to collect by
        these social media platforms.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        In order for you to register for an account on our Website, you must
        provide us with your name, email address and password, or else you may
        not be able to sign up for such account. If you wish to purchase
        products on our Website, you must also provide us with your postal
        address, telephone number and payment verification information.
        Otherwise, we will not be able to process the order for you.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If any Personal Data provided by you do not belong or relate to you but
        to a third party, you hereby agree and confirm that you have provided a
        copy of this Policy to the third party to whom the personal data belongs
        or relates, who has read and agreed to all terms in this Policy, and
        that you have authority from such third party to provide the relevant
        personal data from us.
      </span>
    </p>
    <p className="p2">
      <span className="s1">1.2 Collection of Non-Personal Data</span>
    </p>
    <p className="p2">
      <span className="s1">
        When you use the App and/or Website, we and/or our data processors
        (which process non-personally identifiable data on our behalf) may keep
        an activity log that does not identify you individually and cannot be
        used to identify the identity of any particular visitor of the App
        and/or Website. Generally, we collect and store the following categories
        of data, which shall be considered Non-Personal Data to the extent that
        they do not fall within the definition of &ldquo;Personal Data&rdquo;
        under any laws applicable to our collection, holding, processing and/or
        use of your personal data: to the extent that the laws of certain
        jurisdictions treat this &ldquo;Non-Personal Data&rdquo; as Personal
        Data (for example under EEA Member State laws), CELESTION will comply
        with those laws, as described elsewhere in this Policy.
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s3">
          device information about your mobile or other device that you use to
          access the App and/or Website. This information may include the device
          name, IP address of your device, your device&rsquo;s operating system
          and version, your router name SSID (service set identifier), the type
          of mobile Internet browser you use, the browser&rsquo;s type and
          configuration, the geo-location information and other unique device
          identifiers of the device accessing the App and/or Website, browsing
          preferences such as region, language settings, etc., as well as the
          App version accessed by you;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          device information about the speaker linked to the App and/or Website
          and/or linked to the device that you use to access the App and/or
          Website. This information may include the MAC (media access control)
          address, SSID and firmware of such speaker, as well as the speaker
          sound and volume settings;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          information about your use of the App and/or Website including without
          limitation the specific actions you take on the App and/or Website,
          the number of new or returning visits, statistics on the pages visited
          and referred, a reading history of the pages you have viewed, search
          terms used and search results, error and crash statistics, traffic
          data (such as time and date of access),
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          information about the music played through the App, such as the names
          of music tracks and type of media files that have been played, name of
          media server, music source, playback time, etc.
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        We may collect, use and share to third parties (including those
        specified under section 4 below) these Non-Personal Data, including for
        customizing, enhancing, optimizing, maintaining and/or improving the
        quality of the App and/or Website, such as for determining the optimal
        screen resolution, language and font settings. To the extent that the
        above Non-Personal Data do not amount to personal data under any law
        applicable to our collection, holding, processing and/or use of your
        Personal Data, this Policy in no way restricts or limits our collection,
        use, handling and provision of such Non-Personal Data.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We use web analytics services including Google Firebase Analytics,
        Google Analytics and Google Adwords to obtain various types of
        non-personally identifiable demographics information from our App and/or
        Website users including, but are not limited to, gender, age, location
        and interests our App and Website users. These information are obtained
        for us to operate, maintain and/or improve the App and/or Website.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        1.3 Collection of Your Source IP Address/Location Information
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        When you access the App, we may use GPS or other technologies to
        determine and collect information about the current location of your
        device, if you choose to enable location tracking on your device. This
        geo-location data is collected anonymously in a form that does not
        personally identify you. Advertisements and certain content may be
        directed to your device as a result of this geo-location data. This data
        shall be considered Non-Personal Data to the extent that they do not
        fall within the definition of &ldquo;Personal Data&rdquo; under any laws
        applicable to our collection, holding, processing and/or use of your
        personal data: to the extent that the laws of certain jurisdictions
        treat this &ldquo;Non-Personal Data&rdquo; as Personal Data (for example
        under EEA Member State laws), CELESTION will comply with those laws, as
        described elsewhere in this Privacy Policy. We use geo-location data for
        customizing, providing and improving our services and your browsing
        experience on the App and/or Website. If you enable this feature, the
        current location of your device will be stored locally on your mobile
        device which will be used by the App and/or Website to serve you certain
        contents tied to the relevant location. If you elect to have your
        location-based searches saved to your history, we will store such
        information on our servers. You can choose to turn off location tracking
        at any time by changing the settings on your browser and/or device. This
        will not affect your ability to access or use the CELESTION Website or
        App, but it may mean that we will serve you advertisements or other
        contents that are less relevant to your location.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We may share the geo-location data of your device with our data
        processors for customizing, providing and improving our services and
        your browsing experience on the App and/or Website. When this type of
        data is shared with our data processors for the above purposes, the data
        do not individually identify you, and the other parties do not have
        access to your personally identifiable information.
      </span>
    </p>
    <p className="p2">
      <span className="s1">1.4 Use of cookies</span>
    </p>
    <p className="p2">
      <span className="s1">
        You should be aware that when you use our App and/or Website, we may
        collect information by using cookies, web beacons or unique device
        identifiers to identify your device that is accessing the App and/or
        Website. Cookies are small text files that are stored on your mobile
        device when you access the App or Website, and they record your
        preferences and actions when accessing the same. We use cookies to track
        the use of and the browsing behavior on the App and/or Website, as well
        as to monitor traffic, to maintain and improve the App, and to
        customize, enhance and optimize your browsing experience on the App
        and/or Website to make it easier and/or more convenient for your use.
        Cookies do not recognize you personally and are not harmful to your
        device. None of the cookies that we use contain information such as your
        real name or address, so you cannot be identified personally by them.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Most browsers are initially set up to accept cookies. You can manage and
        adjust your cookies settings at any time by changing the browser setting
        (e.g. Google Chrome setting) for your device to disable cookies or clear
        all cookies and web browsing histories. However, if you choose to
        decline or disable cookies on your device, certain features and
        functionality of the App and/or Website will not work properly, e.g. the
        items added to your shopping cart may be deleted once you exit the App
        and/or Website.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We use the following types of cookies when you access our App and/or
        Website:
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s3">
          <strong>Essential cookies:</strong>&nbsp;These cookies enable you to
          use our Website and/or App; they are essential to enable you to browse
          our Website and/or App and use certain features. Disabling them may
          prevent you from using certain parts of the Website and/or App. These
          cookies also help keep our Website and App safe and secure.
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          <strong>Preference cookies:</strong>&nbsp;These cookies store
          information such as your location data and language selection, login
          data and website preferences. Without these cookies, our Website
          and/or App may not be able to remember certain choices you have
          previously made or personalize your browsing experience by providing
          you with relevant information. These cookies can also be used to
          recognize your device so that you do not have to provide the same
          information more than once.
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          <strong>Performance cookies:</strong>&nbsp;These cookies collect
          information about how you use our Website and/or App, such as which
          pages you visit regularly. These cookies are used to provide you with
          a high-quality experience by doing things such as tracking page load,
          site response times, and error messages. They are also used to gather
          feedback on customer satisfaction through surveys.
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          <strong>Content / advertising cookies:</strong>&nbsp;These cookies
          gather information about your use of our Website and/or App so we may
          improve your experience and provide you with more relevant content and
          advertising. They remember that you've visited our Website and/or App
          and help us understand how you use them. Some of these cookies are
          from third parties that collect information about users of our Website
          and App in order to provide advertising based on users&rsquo; online
          activities. The third parties involved in this type of advertising
          collect internet browsing information (e.g., websites visited, time of
          visit) across different websites and over time, and they may use the
          information they collect on our Website to provide you ads (from us
          and other companies) across the internet.
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        <strong>2. How we use your data</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We may use your Personal Data and Non-Personal Data in the following
        ways:
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s3">
          register, verify and manage your account on the App and/or Website;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          facilitate your log-in access to the App and/or Website including
          through the use of cookies, as described above, e.g. establish and
          maintain your logged-on identity so that you can conveniently browse,
          access and use the App and/or Website without being requested to
          log-on repeatedly;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          processing your purchase orders (whether on the Website, at
          CELESTION&rsquo;s Physical Locations or otherwise) and contacting you
          regarding your purchase orders if necessary, as well as arranging
          delivery of the purchased goods;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          copying, distributing, publishing, sharing or otherwise exploiting
          your user-generated contents on the App, Website or other CELESTION
          social media platforms, in whole or in part, through CELESTION&rsquo;s
          Website, App, other social media accounts (such as CELESTION&rsquo;s
          Facebook and/or Instagram Page) or any other marketing campaigns of
          CELESTION
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          providing product warranty and maintenance services and customer
          and/or technical support to you;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          communicating with you about your account and sending you information
          about our products and services, as well as features of the App and/or
          Website;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          operating, monitoring, customizing, enhancing, maintaining, optimizing
          and/or improving the App, the Website and/or the CELESTION Physical
          Locations as well as our goods and/or services offered and
          customizing, providing and improving our services and your browsing
          experience on the App and/or Website;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          obtaining various types of demographics information from our App
          and/or Website, which we use to operate, maintain and/or improve the
          App and/or Website;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          reviewing and customizing the advertising and content of the App
          and/or Website, as well as promotional materials at CELESTION&rsquo;s
          Physical Locations;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          reviewing, improving and strengthening our marketing strategies,
          including without limitation to formulating and/or conducting market
          analysis and research, such as interviews and focus groups;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          administering contests, competitions and promotions including
          informing you of a prize you have won;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          managing and responding to your comments and inquiries submitted to
          us;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          communicating with you about changes to our policies or terms and
          conditions;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          detecting, investigating and preventing activities that may violate
          our terms and conditions, policies or may be illegal;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          compile, process and generate statistics and crash reports for the App
          and/or Website, and performing statistical, demographic, and marketing
          analyses of our customers as well as users of the App and/or Website;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          compile, maintain and update our database of account holders and users
          on the App and/or Website as well as visitors at the CELESTION
          Physical Locations;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          our customer relationship management (such as conducting consumer
          satisfaction surveys) as well as other internal management or
          administrative purposes in relation to the App, Website and/or
          CELESTION&rsquo;s Physical Locations.
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        <strong>3. Use of Personal Data in Direct Marketing</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We also intend to use your Personal Data in direct marketing, but we
        will not do so without obtaining your prior consent. We and/or our data
        processors acting for and on our behalf may collect and use your name,
        gender, birthday, email and postal address, telephone number, company,
        job title, education, marital status, interests and purchase activity to
        provide you with information regarding our audio and electronic goods
        and services, if you choose to allow us to do so.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Our direct marketing activities may include communication by post,
        telephone, email, SMS, App notifications and/or other mobile
        communication applications (such as WhatsApp, WeChat and/or Line) about
        our App, Website, CELESTION Physical Locations as well as our products,
        services, newsletters, events, contests, competitions, surveys, offers
        and promotions connected with the audio and/or electronic goods and
        services provided by us.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        When you first register for an account on the Website and/or the App or
        when you first provide your personal information to us at the CELESTION
        Physical Locations or through other means of communication such as
        email, if you do not want your Personal Data to be used for direct
        marketing purposes, please do not tick the checkbox which allows you to
        opt into our newsletters and/or direct marketing activities.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You may also change your mind and request that we stop sending you
        direct marking materials/communications or to cease using or providing
        your Personal Data for any direct marketing purposes at any time by
        following the opt-out / unsubscribe facility provided in our marketing
        materials or by emailing us at&nbsp;
        <a href="mailto:data@Celestion.com">
          <span className="s4">data@Celestion.com</span>
        </a>
        . We will, at no cost to you, act on your request within 7 working days
        in order to ensure that you are not included in future direct marketing
        promotions.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We do not share, sell, transfer, provide, rent or trade Personal Data to
        or with third parties for their own direct marketing purposes unless we
        have obtained your consent in accordance with the requirements under the
        applicable law.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>4. Who do we provide your data to?</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We take measures to keep your Personal Data secure and confidential. We
        may share your Personal Data with the following third parties, and will
        only seek your consent to do so if this is required by your local law.:-
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s3">
          third party logistics company in order to arrange delivery of the
          goods you have purchased from our App, Website and/or CELESTION
          Physical Locations;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          agents, contractors or other third-party service providers providing
          administrative, telecommunications, computer, payment, fraud
          prevention, insurance, data processing or other services to us in
          connection with the operation of our business (such as professional
          advisors, telemarketing companies, call center service providers, or
          data entry companies)
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          our affiliates or subsidiaries in the audio and electronics industry
          for the purposes mentioned in section 2 above; and
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          e-commerce platform providers on which CELESTION sells and/or offers
          its products for sale for the purpose of processing your purchase
          orders, sales delivery, conducting CELESTION&rsquo;s marketing
          campaigns as well as any other purposes as specified under section 2
          above for and on CELESTION&rsquo;s behalf.
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        The above parties will only process your Personal Data for and on our
        behalf as set out in this Policy and will not process your Personal Data
        for their own purposes. They owe a duty of confidentiality to us and we
        require them to contractually agree to hold, process and use your
        Personal Data in compliance with this Policy and in accordance with our
        instructions.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We may also share your Personal Data with third party businesses in the
        event that all or substantially all of our assets are sold or
        transferred to another party, or another transaction occurs in which
        your personal information is one of the business assets transferred.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        In addition, we may also share your Personal Data to third party
        websites, mobile apps or social media platforms ("
        <strong>Third Party Services</strong>") if you choose to link or
        otherwise connect your CELESTION membership account or App with such
        Third Party Services. If you choose to connect your CELESTION membership
        account or App with any Third Party Services such as Facebook, you will
        be sharing your Personal Data with these Third Party Services. We are
        not responsible for, have no control over and shall not be liable for
        how the Third Party Services will use, process or share your Personal
        Data. You should make sure you read and agree to their respective
        privacy policies before connecting with any Third Party Services and
        only connect your CELESTION membership account or App with Third Party
        Services that you trust.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We may also disclose your Personal Data to law enforcement agencies,
        regulatory bodies, or other people or entities if such disclosure is
        reasonably necessary to (i) satisfy any applicable law, regulation,
        legal process or enforceable governmental request including but not
        limited to those under the applicable law; (ii) detect, prevent or
        otherwise address fraud or security issues; or (iii) protect against
        harm to the rights, property or safety of us, our subsidiaries,
        affiliates or the public as required or permitted by law.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We may share Non-Personal Data such as demographics and usage statistics
        and the geo-location data of your device with our advertisers, sponsors
        or other organizations. When this type of Non-Personal Data is shared,
        those data do not individually identify you and also cannot be used to
        identify the identity of any particular visitor of the App, and the
        other parties do not have access to your personally identifiable
        information;
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>5. Children&rsquo;s privacy</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We do not knowingly collect personal information from children aged
        under 13 or individuals under the age of majority in the country that
        they live. If you believe that we have inadvertently collected such
        information, please contact us at&nbsp;
        <a href="mailto:data@Celestion.com">
          <span className="s4">data@Celestion.com</span>
        </a>
        &nbsp;so that we can promptly obtain parental consent or remove the
        information.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>6. Data Security</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Physical records of your Personal Data will be stored in a secure
        location with restricted access. Electronic copies of your Personal Data
        will be stored on servers maintained by us and/or our third party
        service providers, which are situated in secure locations and protected
        by adequate data security measures (for example, sensitive data is
        encrypted before being transmitted over the Internet). The App, the
        Website and the computers and servers that supply data to the App and/or
        Website incorporate reasonable safeguards to protect the security,
        integrity, completeness, accuracy and privacy of the Personal Data that
        we may collect and we have put into place reasonable precautions to
        protect such information from loss, destruction, misuse, unauthorized
        access, disclosure and alteration.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We take reasonable administrative, physical and electronic measures
        designed to safeguard and protect your information from unauthorized
        access or disclosure. This includes utilizing Secure Sockets Layer (SSL)
        software, which encrypts the Personal Data and information you input
        (such as Website log-in details), and storing your information in an
        encrypted form behind a firewall designed to block access from outside
        our network.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        However, while we try our best to safeguard your Personal Data once we
        receive it, no security or encryption method can be guaranteed to
        protect information from hackers or human error, and no transmission of
        data over the Internet or any other public network can be guaranteed to
        be 100% secure.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>7. Storage or processing of data</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        The information that we collect may be stored or processed on computers
        or servers located in Hong Kong, Shanghai, United Kingdom, United
        States, as well as any country where we do business. If you are
        accessing the Website and/or the App from and/or visiting
        CELESTION&rsquo;s Physical Locations outside the EEA, by providing us
        with your Personal Data or by accessing and using the App and/or
        Website, you consent to the transfer of your Personal Data to our
        facilities outside of the country in which you have provided your
        Personal Data to us. The personal data protection laws of those
        countries where your Personal Data are stored might not be as stringent
        or comprehensive as those in your country, but we will take all
        reasonable steps to ensure the protection of your privacy and will only
        collect and use your Personal Data for the purposes which are set out in
        this Policy.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you are accessing the Website and/or the App from and/or visiting
        CELESTION&rsquo;s Physical Locations inside the EEA (i.e. including an
        EU Member State), please see Section 13, below, for information about
        our international data transfer practices.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>8. Your obligation to keep your access rights secure</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you register an account on our Website and/or App, you are entirely
        responsible for ensuring and protecting the security and confidentiality
        of your password and account. You are also entirely responsible for any
        and all activities that occur under your account and we shall not be
        held liable for any claims, loss or damage resulting from a breach of
        the foregoing or any unauthorized use of your account.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>9. Data retention</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We will not keep your Personal Data for longer than is necessary to
        fulfil the purposes and any directly-related purposes for which such
        Personal Data is collected. We will take into account any legal
        obligations that require us to retain the Personal Data for a certain
        period of time as well as the duration of your use of our Website and
        App. If you wish to de-register from our Website and/or App, amend or
        update your Personal Data, or request that we no longer use your
        Personal Data to provide you with the information or services you have
        requested, please contact us at &nbsp;
        <a href="mailto:data@Celestion.com">
          <span className="s4">data@Celestion.com</span>
        </a>
        .
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>10. Links to third party websites</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        Our Website and/or App may contain links to third party websites. These
        links are provided solely as a convenience. CELESTION does not endorse
        any third party websites. Access to any other website through any links
        provided on our Website and/or App is at your own risk. CELESTION is not
        responsible for the content of any such websites or the accuracy or
        reliability of any information, data or other contents of those
        websites. We encourage you to consult the privacy policies of any third
        party websites that you visit.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>
          11. Access to, update and withdrawal use of Personal Data
        </strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you are accessing the Website and/or the App from and/or visiting
        CELESTION&rsquo;s Physical Locations outside of the EEA, please note
        that you may exercise your right to know whether we hold your Personal
        Data, what type of Personal Data is held and request access to,
        correction of, or deletion of your Personal Data held by us. If you wish
        to:
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s3">
          have access to your Personal Data, for which we may charge a
          reasonable fee for complying with your request;
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          correct any Personal Data relating to you which is inaccurate; or
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          withdraw your consent to the use of your Personal Data by us (however,
          withdrawing consent may affect your access and use of our App and/or
          Website),
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        you may send such requests or inquiries to our Data Manager at&nbsp;
        <a href="mailto:data@Celestion.com">
          <span className="s4">data@Celestion.com</span>
        </a>
        .
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you are accessing the Website and./or the App from inside the EEA
        (i.e. including an EU Member State), please see Section 13, below, for
        information about your rights as a data subject.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>12. Controlling your Personal Data</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You can stop our collection of information by the App by opting-out
        using the functions in the App. You may also stop our collection of
        information by the App and/or Website by uninstalling the App and by
        cease using the Website. To uninstall the App, you may use the standard
        uninstall processes as may be available as part of your mobile device or
        via the mobile application marketplace or network.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You may always opt-out of receiving communications from us. We provide
        you with the opportunity to opt-out of receiving communications at the
        point where we request information about you and/or provide
        communications to you, or you can contact us via&nbsp;
        <a href="mailto:data@Celestion.com">
          <span className="s4">data@Celestion.com</span>
        </a>
        .
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>13. Users from the European Union</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        This section of the Policy only applies if you are accessing and using
        our Website and/or App from and/or visiting CELESTION&rsquo;s Physical
        Locations in the EEA (including an EU Member State). It supplements the
        information in the rest of the Policy, above.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        GP Acoustics UK Limited is the data controller in respect of the
        processing of users&rsquo; Personal Data collected through the Website,
        the App and/or at CELESTION&rsquo;s Physical Locations.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        13.1 Legal basis for processing of Personal Data
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We describe in Section 1 what types of Personal Data we collect from
        you. In Section 2, we describe the purposes for which we use and process
        that Personal Data. In this section we set out the legal bases on which
        we rely for processing the Personal Data.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        We rely on the following legal bases for processing Personal Data about
        you when you visit our Website, App from and/or the CELESTION Physical
        Locations in the EEA (including an EU Member State):
      </span>
    </p>
    <ul className="ul1">
      <li className="li3">
        <span className="s3">
          It is in CELESTION&rsquo;s legitimate interests to:
        </span>
      </li>
      <ul className="ul1">
        <li className="li3">
          <span className="s3">
            Process your contact information, user name and password for the
            purposes of registering you to our Website and/or App, verifying and
            managing your account, including sending you information about your
            account.
          </span>
        </li>
        <li className="li3">
          <span className="s3">
            Process your name and contact details as described in this Policy in
            order to provide you with information that you seek from CELESTION
            about our products and services, including contacting you with
            information regarding purchases you have made with us and arranging
            delivery of products, as well as customer service support
            information and information about changes to our policies or terms
            and conditions.
          </span>
        </li>
        <li className="li3">
          <span className="s3">
            Process your information such as gender, date of birth, location,
            company, job title, education, marital status and interests, when
            you choose to provide some or all of this information to us, in
            order to understand the demographics of users of our App and/or
            Website and to verify your account.
          </span>
        </li>
        <li className="li3">
          <span className="s3">
            Process information that you choose to publish on our App, Website
            or our social media platforms in order to contribute to our
            marketing campaigns.
          </span>
        </li>
        <li className="li3">
          <span className="s3">
            Process your financial information (including account information
            and purchase activity) in order to fulfil your orders and in order
            to prevent fraud and other illegal activities on our Website and/or
            App.
          </span>
        </li>
        <li className="li3">
          <span className="s3">
            Using information about your visits to and usage of our Website
            and/or App (including your IP address, browsing preferences, device
            information, unique device identifiers, geolocation information and
            other information about your use of the Website and/or App), visits
            to the CELESTION Physical Locations and information you provide us
            in surveys, marketing research questionnaires and/or focus groups in
            which you choose to participate in order to customize, enhance and
            optimize your experience on the Website and/or App and to help us to
            provide, maintain, optimize and improve the Website and/or App and
            improve your experience at the CELESTION Physical Locations.
          </span>
        </li>
        <li className="li3">
          <span className="s3">
            Monitor compliance with our terms and conditions of use on our
            Website and/or App and monitor any illegal activity on our Website
            and/or App.
          </span>
        </li>
      </ul>
      <li className="li3">
        <span className="s3">
          Performing a contract that we have entered into with you to provide
          you with the information, products or services that you have requested
          or purchased from us (or won, in the case of contests, competitions or
          promotions that you have chosen to enter), including fulfilling our
          maintenance services and customer and/or technical support services
          obligations to you.
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          Complying with applicable laws and regulations and CELESTION&rsquo;s
          legal obligations such as accounting and tax requirements.
        </span>
      </li>
      <li className="li3">
        <span className="s3">
          Where necessary, we will procure your consent for processing certain
          Personal Data (for example, with respect to electronic marketing
          communications, as described in Section 3, above, and with respect to
          the use of geolocation data, if you choose to enable location tracking
          on your device, as described in Section 1.3, above). If we process
          your Personal Data on the basis of your consent, you may subsequently
          withdraw that consent at any time by the means indicated at the time
          consent is procured and/or by emailing us at&nbsp;
          <a href="mailto:data@Celestion.com">
            <span className="s5">data@Celestion.com</span>
          </a>
          . This does not affect the lawfulness of the processing that occurred
          on the basis of your earlier consent, before its withdrawal.
        </span>
      </li>
    </ul>
    <p className="p2">
      <span className="s1">
        You are not required to provide CELESTION with Personal Data when you
        visit or use our Website and/or App or when you visit the CELESTION
        Physical Locations, but if you do not do so in the circumstances
        described above, we will not be able to provide you with certain
        information you request or with all of our products and services, and
        you will not be able to use all the features of our Website and/or App.
      </span>
    </p>
    <p className="p2">
      <span className="s1">13.2 International data transfers</span>
    </p>
    <p className="p2">
      <span className="s1">
        Please note that your Personal Data may be transferred to CELESTION
        affiliates or subsidiaries operating in countries outside the EEA,
        including but not limited to the United States, Hong Kong, China,
        Singapore, Taiwan, Japan and Dubai. In addition, the service providers
        and other third parties with whom CELESTION may share information (as
        described in Section 4) may be based outside the EEA. Data protection
        laws may or may not apply in jurisdictions outside the EEA or may not be
        as stringent as those in the EEA. In any case, CELESTION will implement
        appropriate contractual measures (such as standard data protection
        clauses, a copy of which you can obtain by contacting&nbsp;
        <a href="mailto:data@Celestion.com">
          <span className="s4">data@Celestion.com</span>
        </a>
        ) to ensure that the relevant CELESTION entities and third parties
        outside the EEA provide an adequate level of protection to your Personal
        Data as set out in this Policy and as required by applicable local law.
      </span>
    </p>
    <p className="p2">
      <span className="s1">13.3 Your rights as a data subject</span>
    </p>
    <p className="p2">
      <span className="s1">
        You are entitled to request access to, rectification or erasure of
        Personal Data relating to you or restriction of processing or to object
        to processing of such Personal Data and other rights in accordance with
        applicable law. You may also ask for your Personal Data to be ported to
        third parties in accordance with applicable law. If you wish to enforce
        your rights, please contact us at&nbsp;
        <a href="mailto:data@Celestion.com">
          <span className="s4">data@Celestion.com</span>
        </a>
        . We will provide you with a response in accordance with applicable data
        protection law. CELESTION may refuse to provide such information in
        limited circumstances under applicable local law.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        You also have the right to lodge a complaint before your local data
        privacy authority should we violate applicable data privacy laws(s) in
        our processing of your personal information.
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        <strong>14. Enquiries / Contact Us</strong>
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        This Policy applies to the collection, use, holding and processing of
        your personal data by us, which includes the following entities:
        <br /> - GP Acoustics UK Limited
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you have any questions or complaints, or if you wish to access or
        correct your Personal Data or withdraw your consent to the use of your
        Personal Data held by us, or exercise any of your other rights, please
        contact our Data Manager at&nbsp;
        <a href="mailto:data@Celestion.com">
          <span className="s4">data@Celestion.com</span>
        </a>
        .
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        If you are a data subject in the EEA (including an EU Member State), you
        may also contact us by post via any one of the following addresses
        closest to you:-
      </span>
    </p>
    <p className="p2">
      <span className="s1">
        GP Acoustics (UK) Limited
        <br /> Park House
        <br /> Crawley Business Quarter
        <br /> Manor Royal
        <br /> Crawley
        <br /> West Sussex
        <br /> RH10 9AD United Kingdom
      </span>
    </p>
  </section>
);
